export const btnPrimary = {
  background: '#3b82b8 !important',
  color: '#fff !important',
  padding: '10px 20px',
  borderRadius: '200px !important',
  fontSize: 12,
  fontWeight: 700,
  textTransform: 'none',
  lineHeight: '14px',
  border: 'none !important',
  boxShadow: 'none !important',
  '&:hover': {
    background: '#2d6a9f !important',
  },
  '&:disabled, &.Mui-disabled': {
    background: '#a0b8cc !important',
    color: '#fff !important',
    cursor: 'not-allowed',
    pointerEvents: 'auto',
  },
};

export const btnDefault = {
  background: '#fff !important',
  color: '#5e6469 !important',
  padding: '10px 20px',
  borderRadius: '200px !important',
  fontSize: 12,
  fontWeight: 700,
  textTransform: 'none',
  lineHeight: '14px',
  border: '1px solid #ccc !important',
  boxShadow: 'none !important',
  '&:hover': {
    background: '#f5f5f5 !important',
  },
};
